export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14966.f3f81fd4.jpg";